var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-accordion',[(_vm.visible)?_c('m-container',{staticClass:"home-table-section-header"},[_c('p',{staticClass:"home-table-section-header__name"},[_vm._t("default")],2)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }